import React from 'react'
import cls from 'classnames'
import PropTypes from 'prop-types'

import permManager from 'utils/permManager'

import { PLAN_TYPES } from 'containers/App/constants'
import LandingForm from 'containers/Settings/MailboxProtection/LandingForm'

import DataContainer from 'components/elements/DataContainer'
import SettingsHeader from 'components/elements/SettingsHeader'

import MailboxProtectionSettings from './MailboxProtectionSettings'

require('components/styles/layouts/settings/accountSettings.styl')

class MailboxProtectionSettingsPage extends React.Component {
  state = {
    error: null,
  }

  componentWillMount() {
    const { isGroupSettings } = this.props
    if (!isGroupSettings) this.props.getMailboxProtection()
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.error) {
      this.setState({
        error: { ...nextProps.error, refreshAction: this.props.fetchData },
      })
    } else if (this.state.error) {
      this.setState({ error: null })
    }
  }

  componentWillUnmount() {
    const { isGroupSettings } = this.props
    if (!isGroupSettings) this.props.getMailboxProtectionCancel()
  }

  render() {
    const { error } = this.state
    const {
      data,
      loader,
      companyFilter,
      integrations,
      licenses,
      permissions,

      enabledLanguages,
      selectedBannersLanguage,

      changeField,
      changeBannersLanguage,
      updMailboxProtection,

      isGroupSettings,
      groupSettingsNameByPartner,

      isStaticSalesDemo,
    } = this.props

    return (
      <React.Fragment>
        <div className={cls('card pz', { scrollable: !loader })} id="Settings_ScrollToTop_card">
          <SettingsHeader header="Threat Protection" subHeader="Impersonation Protection" />
          <DataContainer
            error={error}
            loader={loader}
            className={cls({ 'with-loader': loader })}
            partnerAccess={{
              companyFilter,
              checkPartnerAccess:
                permManager.pages.settings.threats_protection.business_email_compromise,
            }}
          >
            <MailboxProtectionSettings
              {...{
                data,
                integrations,
                licenses,
                permissions,

                enabledLanguages,
                selectedBannersLanguage,

                changeField,
                changeBannersLanguage,
                updMailboxProtection,

                isGroupSettings,
                groupSettingsNameByPartner,

                isStaticSalesDemo,
              }}
            />
          </DataContainer>
        </div>
        {licenses.plan !== PLAN_TYPES.STARTER && <LandingForm isGroupSettings={isGroupSettings} />}
      </React.Fragment>
    )
  }
}

MailboxProtectionSettingsPage.propTypes = {
  getMailboxProtection: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
  updMailboxProtection: PropTypes.func.isRequired,
}

export default MailboxProtectionSettingsPage
